var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalarAgora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "falar_agora") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-1692.000000, -548.000000)",
    stroke: "",
    strokeWidth: 2.94
  }, /*#__PURE__*/React.createElement("g", {
    id: "falar_agora",
    transform: "translate(1694.000000, 550.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,15.5533404 L39,21.385843 C39,29.1625132 35.1,33.0508483 27.3,33.0508483 L26.325,33.0508483 C25.7205,33.0508483 25.1354996,33.3424727 24.7649996,33.8285146 L21.8399996,37.7168497 C20.5529996,39.4277171 18.4470004,39.4277171 17.1600004,37.7168497 L14.2350004,33.8285146 C13.9230004,33.4007978 13.2015,33.0508483 12.675,33.0508483 L11.7,33.0508483 C3.9,33.0508483 0,31.1066808 0,21.385843 L0,11.6650053 C0,3.8883351 3.9,0 11.7,0 L23.4,0",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero",
    transform: "translate(19.500000, 19.500000) scale(-1, 1) translate(-19.500000, -19.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6639992,23.9040001 C27.4599992,24.3360001 27.1960011,24.7440006 26.8480011,25.1280006 C26.2600011,25.7760007 25.6119996,26.244001 24.8799995,26.544001 C24.1599995,26.844001 23.3800009,27 22.5400009,27 C21.3160009,27 20.0079995,26.7120006 18.6279995,26.1240005 C17.2479995,25.5360005 15.868,24.7440011 14.5,23.7480011 C13.12,22.7400011 11.8119997,21.6239997 10.5639997,20.3879997 C9.32799978,19.1399998 8.21199977,17.8320003 7.21599979,16.4640003 C6.2319998,15.0960003 5.44000002,13.7280005 4.86400003,12.3720005 C4.28800005,11.0040005 4,9.69599991 4,8.44799995 C4,7.63199995 4.14399988,6.85200019 4.43199987,6.13200016 C4.71999987,5.40000014 5.17600002,4.72800007 5.81199999,4.12800007 C6.57999997,3.37200007 7.42000017,3 8.30800018,3 C8.64400018,3 8.98000011,3.07200008 9.28000011,3.21600008 C9.5920001,3.36000008 9.8680002,3.57600002 10.0840002,3.88800001 L12.8680004,7.81200027 C13.0840004,8.11200027 13.2399999,8.38800005 13.348,8.65200005 C13.456,8.90400004 13.5160004,9.15600021 13.5160004,9.38400021 C13.5160004,9.6720002 13.4320003,9.95999967 13.2640003,10.2359997 C13.1080003,10.5119997 12.8799998,10.7999997 12.5919998,11.0879997 L11.6799995,12.0359997 C11.5479995,12.1679997 11.4879997,12.3240004 11.4879997,12.5160004 C11.4879997,12.6120004 11.5,12.6959998 11.5240005,12.7919998 C11.5600005,12.8879998 11.5960005,12.9599996 11.6200005,13.0319996 C11.8360005,13.4279996 12.2079997,13.9440004 12.7359997,14.5680004 C13.2759997,15.1920004 13.8519995,15.8280004 14.4759995,16.4640003 C15.1239995,17.1000003 15.7479997,17.6879995 16.3839996,18.2279995 C17.0079996,18.7559995 17.5239996,19.1159996 17.9319996,19.3319996 C17.9919996,19.3559996 18.064,19.3919995 18.148,19.4279995 C18.244,19.4639995 18.3399999,19.4759995 18.448,19.4759995 C18.652,19.4759995 18.8079998,19.4040005 18.9399998,19.2720005 L19.852,18.3720005 C20.152,18.0720005 20.4400004,17.844 20.7160004,17.7 C20.9920004,17.532 21.2679993,17.448 21.5679993,17.448 C21.7959993,17.448 22.036,17.4960001 22.3,17.6040001 C22.564,17.7120001 22.8400009,17.8680005 23.1400009,18.0720005 L27.1120003,20.8919998 C27.4240003,21.1079998 27.6399994,21.3599991 27.7719994,21.6599991 C27.8919994,21.9599991 27.9639992,22.2599999 27.9639992,22.5959999 C27.9639992,23.0279999 27.8679992,23.4720001 27.6639992,23.9040001 Z",
    id: "Vector",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 7.5,
    x2: 31.5,
    y2: 7.5,
    id: "Line-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 13.5,
    x2: 31.5,
    y2: 13.5,
    id: "Line-2-Copy",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalarAgora);
export default __webpack_public_path__ + "static/media/falar_agora.b615ec0f3750490f4b44cf6e523f4ad4.svg";
export { ForwardRef as ReactComponent };